const DOCUMENT = 'APPLICANT_SUPERANNUATIONS_';

const actions = {
  LOAD_REQUEST: DOCUMENT + 'LOAD_REQUEST',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  EDIT: DOCUMENT + 'EDIT',
  EDIT_SUCCESS: DOCUMENT + 'EDIT_SUCCESS',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  LOAD_ABN_SUGGESTIONS_REQUEST: DOCUMENT + 'LOAD_ABN_SUGGESTIONS_REQUEST',
  LOAD_ABN_SUGGESTIONS_SUCCESS: DOCUMENT + 'LOAD_ABN_SUGGESTIONS_SUCCESS',
  LOAD_SUPERFUND_SUGGESTIONS_REQUEST: DOCUMENT + 'LOAD_SUPERFUND_SUGGESTIONS_REQUEST',
  LOAD_SUPERFUN_SUGGESTIONS_SUCCESS: DOCUMENT + 'LOAD_SUPERFUN_SUGGESTIONS_SUCCESS',
  UPDATE: DOCUMENT + 'UPDATE',
  UPDATE_SUCCESS: DOCUMENT + 'UPDATE_SUCCESS',
  TOUCH: DOCUMENT + 'TOUCH',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  CANCEL: DOCUMENT + 'CANCEL',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadDataRequest: data => ({ type: actions.LOAD_REQUEST, payload: data }),
  loadDataSuccess: data => ({ type: actions.LOAD_SUCCESS, payload: data }),
  loadFormData: data => ({ type: actions.LOAD_FORM_DATA, payload: data }),
  loadFormDataSuccess: data => ({ type: actions.LOAD_FORM_DATA_SUCCESS, payload: data }),
  edit: data => ({ type: actions.EDIT, payload: data }),
  editSuccess: data => ({ type: actions.EDIT_SUCCESS, payload: data }),
  save: data => ({ type: actions.SAVE, payload: data }),
  saveSuccess: data => ({ type: actions.SAVE_SUCCESS, payload: data }),
  loadAbnSuggestionsRequest: data => ({ type: actions.LOAD_ABN_SUGGESTIONS_REQUEST, payload: data }),
  loadAbnSuggestionsSuccess: data => ({ type: actions.LOAD_ABN_SUGGESTIONS_SUCCESS, payload: data }),
  loadSuperfundSuggestionsRequest: data => ({ type: actions.LOAD_SUPERFUND_SUGGESTIONS_REQUEST, payload: data }),
  loadSuperfundSuggestionsSuccess: data => ({ type: actions.LOAD_SUPERFUN_SUGGESTIONS_SUCCESS, payload: data }),
  update: data => ({ type: actions.UPDATE, payload: data }),
  updateSuccess: () => ({ type: actions.UPDATE_SUCCESS }),
  touch: data => ({ type: actions.TOUCH, payload: data }),
  changeProperty: data => ({ type: actions.CHANGE_PROPERTY, payload: data }),
  cancel: () => ({ type: actions.CANCEL }),
  saveError: data => ({ type: actions.SAVE_ERROR, payload: data }),
  clearStore: () => ({ type: actions.CLEAR_STORE }),
};

export default actions;
